import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mapper-value-spec-form"
  }, [_c(VBtnToggle, {
    staticClass: "mapper-value-spec-form__kinds",
    attrs: {
      "value": _vm.value.kind,
      "dense": "",
      "mandatory": ""
    },
    on: {
      "change": function ($event) {
        return _vm.setKind($event);
      }
    }
  }, _vm._l(_vm.kinds, function (kind) {
    return _c(VBtn, {
      key: kind,
      attrs: {
        "value": kind,
        "disabled": _vm.disabled,
        "small": "",
        "data-test": `${_vm.dataTest}-kind-${kind}`
      }
    }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t(`Bridges.mapperBuilder.valueSpec.kinds.${kind}`)) + "\n    ")]);
  }), 1), _c('p', {
    staticClass: "mapper-value-spec-form__hint text--secondary"
  }, [_vm._v("\n    " + _vm._s(_vm.$i18n_t(`Bridges.mapperBuilder.valueSpec.kindHints.${_vm.value.kind}`)) + "\n  ")]), _vm.value.kind === 'literal' ? _c('mapper-literal-field', {
    attrs: {
      "value": _vm.value.literal,
      "label": _vm.$i18n_t('Bridges.mapperBuilder.valueSpec.literalValue'),
      "disabled": _vm.disabled,
      "data-test": `${_vm.dataTest}-literal`
    },
    on: {
      "change": function ($event) {
        return _vm.$emit('change');
      }
    }
  }) : _vm.value.kind === 'path' ? _c(VTextField, {
    attrs: {
      "value": _vm.value.path,
      "label": _vm.$i18n_t('Bridges.mapperBuilder.valueSpec.path'),
      "hint": _vm.$i18n_t('Bridges.mapperBuilder.valueSpec.pathHint'),
      "disabled": _vm.disabled,
      "dense": "",
      "outlined": "",
      "persistent-hint": "",
      "data-test": `${_vm.dataTest}-path`
    },
    on: {
      "input": function ($event) {
        return _vm.setField('path', $event);
      }
    }
  }) : _vm.value.kind === 'capture' ? _c(VCombobox, {
    attrs: {
      "value": _vm.value.capture,
      "items": _vm.captures,
      "label": _vm.$i18n_t('Bridges.mapperBuilder.valueSpec.capture'),
      "hint": _vm.$i18n_t('Bridges.mapperBuilder.valueSpec.captureHint'),
      "disabled": _vm.disabled,
      "dense": "",
      "outlined": "",
      "persistent-hint": "",
      "data-test": `${_vm.dataTest}-capture`
    },
    on: {
      "input": function ($event) {
        return _vm.setField('capture', $event);
      }
    }
  }) : [_c(VCombobox, {
    staticClass: "mb-3",
    attrs: {
      "value": _vm.value.lookup.table,
      "items": _vm.lookupTables,
      "label": _vm.$i18n_t('Bridges.mapperBuilder.valueSpec.lookupTable'),
      "disabled": _vm.disabled,
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "data-test": `${_vm.dataTest}-lookup-table`
    },
    on: {
      "input": function ($event) {
        return _vm.setLookupTable($event);
      }
    }
  }), _c(VBtnToggle, {
    staticClass: "mapper-value-spec-form__kinds",
    attrs: {
      "value": _vm.value.lookup.source,
      "dense": "",
      "mandatory": ""
    },
    on: {
      "change": function ($event) {
        return _vm.setLookupSource($event);
      }
    }
  }, _vm._l(_vm.lookupKeySources, function (source) {
    return _c(VBtn, {
      key: source,
      attrs: {
        "value": source,
        "disabled": _vm.disabled,
        "small": "",
        "data-test": `${_vm.dataTest}-lookup-source-${source}`
      }
    }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t(`Bridges.mapperBuilder.valueSpec.lookupSources.${source}`)) + "\n      ")]);
  }), 1), _vm.value.lookup.source === 'from' && _vm.value.lookup.from ? _c('div', {
    staticClass: "mapper-value-spec-form__nested"
  }, [_c('span', {
    staticClass: "mapper-value-spec-form__nested-label text--secondary"
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.valueSpec.lookupFrom')) + "\n      ")]), _c('mapper-value-spec-form', {
    attrs: {
      "value": _vm.value.lookup.from,
      "captures": _vm.captures,
      "lookup-tables": _vm.lookupTables,
      "disabled": _vm.disabled,
      "data-test": `${_vm.dataTest}-lookup-from`
    },
    on: {
      "change": function ($event) {
        return _vm.$emit('change');
      }
    }
  })], 1) : _vm.value.lookup.source === 'key' ? _c('mapper-literal-field', {
    attrs: {
      "value": _vm.value.lookup.key,
      "label": _vm.$i18n_t('Bridges.mapperBuilder.valueSpec.lookupKey'),
      "disabled": _vm.disabled,
      "data-test": `${_vm.dataTest}-lookup-key`
    },
    on: {
      "change": function ($event) {
        return _vm.$emit('change');
      }
    }
  }) : _vm._e()], _vm.value.kind !== 'literal' ? [_c('div', {
    staticClass: "mapper-value-spec-form__transforms-header"
  }, [_c('span', {
    staticClass: "text--secondary"
  }, [_vm._v(_vm._s(_vm.$i18n_t('Bridges.mapperBuilder.valueSpec.transforms')))]), _c(VMenu, {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c(VBtn, _vm._g(_vm._b({
          attrs: {
            "disabled": _vm.disabled,
            "small": "",
            "text": "",
            "data-test": `${_vm.dataTest}-add-transform`
          }
        }, 'v-btn', attrs, false), on), [_c(VIcon, {
          attrs: {
            "left": "",
            "size": "14"
          }
        }, [_vm._v("fal fa-plus")]), _vm._v("\n            " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.valueSpec.addTransform')) + "\n          ")], 1)];
      }
    }], null, false, 2480239133)
  }, [_c(VList, {
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.transformTypes, function (type) {
    return _c(VListItem, {
      key: type,
      attrs: {
        "data-test": `${_vm.dataTest}-add-transform-${type}`
      },
      on: {
        "click": function ($event) {
          return _vm.addTransform(type);
        }
      }
    }, [_c(VListItemTitle, [_vm._v("\n              " + _vm._s(_vm.$i18n_t(`Bridges.mapperBuilder.transforms.${type}`)) + "\n            ")])], 1);
  }), 1)], 1)], 1), _vm.value.transforms.length === 0 ? _c('p', {
    staticClass: "mapper-value-spec-form__hint text--secondary"
  }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Bridges.mapperBuilder.valueSpec.noTransforms')) + "\n    ")]) : _vm._e(), _vm._l(_vm.value.transforms, function (transform, transformIndex) {
    return _c('div', {
      key: transform.uiKey,
      staticClass: "mapper-value-spec-form__transform"
    }, [_c('div', {
      staticClass: "mapper-value-spec-form__transform-row"
    }, [_c('span', {
      staticClass: "mapper-value-spec-form__transform-index text--secondary"
    }, [_vm._v(_vm._s(transformIndex + 1) + ".")]), _c(VSelect, {
      attrs: {
        "value": transform.type,
        "items": _vm.transformItems,
        "label": _vm.$i18n_t('Bridges.mapperBuilder.valueSpec.transform'),
        "disabled": _vm.disabled,
        "dense": "",
        "hide-details": "",
        "outlined": "",
        "data-test": `${_vm.dataTest}-transform-${transformIndex}-type`
      },
      on: {
        "change": function ($event) {
          return _vm.setTransformType(transform, $event);
        }
      }
    }), _c(VBtn, {
      attrs: {
        "disabled": _vm.disabled || transformIndex === 0,
        "icon": "",
        "small": "",
        "title": _vm.$i18n_t('Bridges.mapperBuilder.valueSpec.moveTransformUp'),
        "data-test": `${_vm.dataTest}-transform-${transformIndex}-up`
      },
      on: {
        "click": function ($event) {
          return _vm.moveTransform(transformIndex, -1);
        }
      }
    }, [_c(VIcon, {
      attrs: {
        "size": "14"
      }
    }, [_vm._v("fal fa-arrow-up")])], 1), _c(VBtn, {
      attrs: {
        "disabled": _vm.disabled || transformIndex === _vm.value.transforms.length - 1,
        "icon": "",
        "small": "",
        "title": _vm.$i18n_t('Bridges.mapperBuilder.valueSpec.moveTransformDown'),
        "data-test": `${_vm.dataTest}-transform-${transformIndex}-down`
      },
      on: {
        "click": function ($event) {
          return _vm.moveTransform(transformIndex, 1);
        }
      }
    }, [_c(VIcon, {
      attrs: {
        "size": "14"
      }
    }, [_vm._v("fal fa-arrow-down")])], 1), _c(VBtn, {
      attrs: {
        "disabled": _vm.disabled,
        "icon": "",
        "small": "",
        "title": _vm.$i18n_t('Bridges.mapperBuilder.valueSpec.removeTransform'),
        "data-test": `${_vm.dataTest}-transform-${transformIndex}-remove`
      },
      on: {
        "click": function ($event) {
          return _vm.removeTransform(transformIndex);
        }
      }
    }, [_c(VIcon, {
      attrs: {
        "size": "14"
      }
    }, [_vm._v("fal fa-trash-alt")])], 1)], 1), transform.type === 'multiply' || transform.type === 'divide' ? _c(VTextField, {
      staticClass: "mt-2",
      attrs: {
        "value": transform.amount,
        "label": _vm.$i18n_t('Bridges.mapperBuilder.valueSpec.factor'),
        "disabled": _vm.disabled,
        "dense": "",
        "hide-details": "",
        "outlined": "",
        "type": "number",
        "data-test": `${_vm.dataTest}-transform-${transformIndex}-amount`
      },
      on: {
        "input": function ($event) {
          return _vm.setTransformAmount(transform, $event);
        }
      }
    }) : transform.type === 'scalePow10' ? [_c(VBtnToggle, {
      staticClass: "mapper-value-spec-form__kinds mt-2",
      attrs: {
        "value": transform.scaleSource,
        "dense": "",
        "mandatory": ""
      },
      on: {
        "change": function ($event) {
          return _vm.setScaleSource(transform, $event);
        }
      }
    }, _vm._l(_vm.scaleSources, function (source) {
      return _c(VBtn, {
        key: source,
        attrs: {
          "value": source,
          "disabled": _vm.disabled,
          "small": "",
          "data-test": `${_vm.dataTest}-transform-${transformIndex}-scale-${source}`
        }
      }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t(`Bridges.mapperBuilder.valueSpec.scaleSources.${source}`)) + "\n          ")]);
    }), 1), transform.scaleSource === 'number' ? _c(VTextField, {
      staticClass: "mt-2",
      attrs: {
        "value": transform.amount,
        "label": _vm.$i18n_t('Bridges.mapperBuilder.valueSpec.exponent'),
        "disabled": _vm.disabled,
        "dense": "",
        "hide-details": "",
        "outlined": "",
        "type": "number",
        "data-test": `${_vm.dataTest}-transform-${transformIndex}-amount`
      },
      on: {
        "input": function ($event) {
          return _vm.setTransformAmount(transform, $event);
        }
      }
    }) : _c('div', {
      staticClass: "mapper-value-spec-form__nested"
    }, [_c('mapper-value-spec-form', {
      attrs: {
        "value": transform.spec,
        "captures": _vm.captures,
        "lookup-tables": _vm.lookupTables,
        "disabled": _vm.disabled,
        "data-test": `${_vm.dataTest}-transform-${transformIndex}-spec`
      },
      on: {
        "change": function ($event) {
          return _vm.$emit('change');
        }
      }
    })], 1)] : transform.type === 'default' ? _c('mapper-literal-field', {
      staticClass: "mt-2",
      attrs: {
        "value": transform.literal,
        "label": _vm.$i18n_t('Bridges.mapperBuilder.valueSpec.fallbackValue'),
        "disabled": _vm.disabled,
        "allow-json": "",
        "data-test": `${_vm.dataTest}-transform-${transformIndex}-default`
      },
      on: {
        "change": function ($event) {
          return _vm.$emit('change');
        }
      }
    }) : _vm._e()], 2);
  })] : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };